module.exports = __webpack_public_path__ + "4c370c70862337f50e8b9c0997514c6b.jpg";